import React, { useContext, } from 'react';

interface Props {
  children: React.ReactNode;
  settings?: any
}

export const AppSettingsContext = React.createContext({
  baseURL: '',
  intercomAppId: '',
  turnstileSiteKey: '',
  turnstileSiteEnabled: 'false',
  googleMapsApiKey: '',
  tempProtectedRoutesKey: '',
  burnInURL: '',
  triggerManualAlertUrl: '',
  handleLockCommandsUrl: '',
  handleResetCommandsUrl: '',
  statusRequestCommandUrl: '',
  sendEmailHandlerUrl: '',
  manualUpdateDeviceRegionUrl: '',
  updateDeviceAutoLockUrl: '',
  getDeviceConfigurationUrl: '',
  addUserUrl: '',
  updateUserUrl: '',
  deleteUserUrl: '',
  deviceEventsUrl: '',
  getRemotesUrl: '',
  executeToolUrl: '',
  threeDtAddCompanyUrl: '',
  threeDtAddVehicleUrl: '',
  sendPasswordResetNotificationUrl: '',
  reapplyConfigurationUrl: '',
  installationChecklistAutoLockDelaySeconds: '',
  resetPasswordUrl: '',
  firebaseApiKey: '',
  firebaseAuthDomain: '',
  firebaseProjectId: '',
  firebaseStorageBucket: '',
  firebaseMessagingSenderId: '',
  firebaseAppId: '',
  titanRegionId: '',
  disableWireTamperChecklistSteps: '',
  installationChecklistFuelCutDisabled: '',
  installationChecklistAutolockDisabled: ''
});

export const AppSettingsContextProvider = ({ children, settings }: Props) => {
  return (
    <AppSettingsContext.Provider value={{ ...settings }}>
      {children}
    </AppSettingsContext.Provider>
  );
};

export function useAppSettings() {
  const context = useContext(AppSettingsContext);
  return context;
}